import { render, staticRenderFns } from "./PAKurzpruefung.vue?vue&type=template&id=217a0a5b&"
import script from "./PAKurzpruefung.vue?vue&type=script&lang=js&"
export * from "./PAKurzpruefung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports